
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { useLanguage } from "@/components/LanguageContext";
import { useTranslations } from "@/hooks/useTranslations";

interface WeightChartProps {
  data: any[];
}

export const WeightChart = ({ data }: WeightChartProps) => {
  const { language } = useLanguage();
  const { t } = useTranslations("student");
  
  if (!data || data.length === 0) {
    return (
      <Card className="shadow-md border border-slate-100 dark:border-gray-700 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm">
        <CardHeader className="pb-2">
          <CardTitle className="text-xl font-semibold dark:text-white">{t("overview.charts.weight")}</CardTitle>
        </CardHeader>
        <CardContent className="flex items-center justify-center h-[300px]">
          <p className="text-muted-foreground dark:text-gray-400">
            {t("overview.charts.noWeightData")}
          </p>
        </CardContent>
      </Card>
    );
  }
  
  return (
    <Card className="shadow-md border border-slate-100 dark:border-gray-700 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm">
      <CardHeader className="pb-2">
        <CardTitle className="text-xl font-semibold dark:text-white">{t("overview.charts.weight")}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[300px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={data}
              margin={{
                top: 10,
                right: 30,
                left: 0,
                bottom: 0,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#474747" strokeOpacity={0.3} />
              <XAxis 
                dataKey="date" 
                stroke="#9CA3AF" 
                tick={{ fill: "#E5E7EB" }}
                axisLine={{ stroke: '#555' }}
                tickMargin={10}
                className="text-xs dark:text-slate-400"
              />
              <YAxis 
                stroke="#9CA3AF" 
                tick={{ fill: "#E5E7EB" }}
                axisLine={{ stroke: '#555' }}
                className="text-xs dark:text-slate-400"
              />
              <Tooltip
                formatter={(value: any) => [`${value} kg`, '']}
                contentStyle={{ 
                  backgroundColor: 'rgba(31, 41, 55, 0.9)',
                  borderRadius: '8px',
                  border: '1px solid #4B5563',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                  color: '#E5E7EB'
                }}
              />
              <Line 
                type="monotone" 
                dataKey="weight" 
                stroke="#2563EB" 
                strokeWidth={3}
                dot={{ fill: '#2563EB', r: 4 }}
                activeDot={{ r: 6 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};
